"use strict";

var _regeneratorRuntime = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable:max-line-length */

/* tslint:disable:interface-name */

require('es6-promise').polyfill();
/* tslint:disable-line */


require('isomorphic-fetch');
/* tslint:disable-line */


var BcRpcMethod;

(function (BcRpcMethod) {
  BcRpcMethod["NewTx"] = "newTx";
  BcRpcMethod["GetSpendableOutpoints"] = "getSpendableOutpoints";
  BcRpcMethod["GetBalance"] = "getBalance";
  BcRpcMethod["GetWallet"] = "getWallet";
  BcRpcMethod["GetSpendableCollateral"] = "getSpendableCollateral";
  BcRpcMethod["GetUnlockTakerTxParams"] = "getUnlockTakerTxParams";
  BcRpcMethod["PlaceMakerOrder"] = "placeMakerOrder";
  BcRpcMethod["PlaceTakerOrder"] = "placeTakerOrder";
  BcRpcMethod["PlaceTakerOrders"] = "placeTakerOrders";
  BcRpcMethod["CalculateMakerFee"] = "calculateMakerFee";
  BcRpcMethod["CalculateTakerFee"] = "calculateTakerFee";
  BcRpcMethod["GetOpenOrders"] = "getOpenOrders";
  BcRpcMethod["GetMatchedOrders"] = "getMatchedOrders";
  BcRpcMethod["GetBlake2bl"] = "getBlake2bl";
  BcRpcMethod["GetTxClaimedBy"] = "getTxClaimedBy";
  BcRpcMethod["GetTradeStatus"] = "getTradeStatus";
  BcRpcMethod["GetOutpointStatus"] = "getOutpointStatus";
  BcRpcMethod["GetBcAddressViaVanity"] = "getBcAddressViaVanity";
  BcRpcMethod["GetLatestBlock"] = "getLatestBlock";
  BcRpcMethod["GetLatestRoveredBlocks"] = "getLatestRoveredBlocks";
  BcRpcMethod["GetBlockHeight"] = "getBlockHeight";
  BcRpcMethod["GetBlockHash"] = "getBlockHash";
  BcRpcMethod["GetRoveredBlockHeight"] = "getRoveredBlockHeight";
  BcRpcMethod["GetRoveredBlockHash"] = "getRoveredBlockHash";
  BcRpcMethod["GetBlocks"] = "getBlocks";
  BcRpcMethod["GetRoveredBlocks"] = "getRoveredBlocks";
  BcRpcMethod["GetTx"] = "getTx";
  BcRpcMethod["GetMarkedTx"] = "getMarkedTx";
  BcRpcMethod["SendTx"] = "sendTx";
})(BcRpcMethod || (BcRpcMethod = {}));

function btoa(str) {
  var buffer;

  if (str instanceof Buffer) {
    buffer = str;
  } else {
    buffer = Buffer.from(str.toString(), 'binary');
  }

  return buffer.toString('base64');
}

var RpcClient =
/*#__PURE__*/
function () {
  function RpcClient(nodeUrl, authToken) {
    _classCallCheck(this, RpcClient);

    this.rpcUrl = new URL(nodeUrl);

    if (authToken) {
      this.defaultHeaders = {
        'Content-Type': 'application/json',
        'authorization': 'Basic ' + btoa(":".concat(authToken))
      };
    } else {
      if (this.rpcUrl.protocol === 'https:') {
        throw new Error('You have to provide an authToken with https:// scheme');
      }

      this.defaultHeaders = {
        'Content-Type': 'application/json'
      };
    }
  }

  _createClass(RpcClient, [{
    key: "getRoveredBlockHash",
    value: function getRoveredBlockHash(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetRoveredBlockHash, request.toArray());

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getRoveredBlockHeight",
    value: function getRoveredBlockHeight(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetRoveredBlockHeight, request.toArray());

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getRoveredBlocks",
    value: function getRoveredBlocks(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetRoveredBlocks, request.toArray());

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getLatestRoveredBlock",
    value: function getLatestRoveredBlock() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetLatestRoveredBlocks, []);

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getBlockHash",
    value: function getBlockHash(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetBlockHash, request.toArray());

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", result);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getBlockHeight",
    value: function getBlockHeight(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetBlockHeight, request.toArray());

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", result);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getBlocks",
    value: function getBlocks(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetBlocks, request.toArray());

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", result);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getLatestBlock",
    value: function getLatestBlock() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetLatestBlock, []);

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", result);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "getTx",
    value: function getTx(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var result;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetTx, request.toArray());

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", result);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "getMarkedTx",
    value: function getMarkedTx(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var result;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetMarkedTx, request.toArray());

              case 2:
                result = _context10.sent;
                return _context10.abrupt("return", result);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "newTx",
    value: function newTx(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var result;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.NewTx, request.toArray());

              case 2:
                result = _context11.sent;
                return _context11.abrupt("return", result);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getBalance",
    value: function getBalance(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var result;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetBalance, request.toArray());

              case 2:
                result = _context12.sent;
                return _context12.abrupt("return", result);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "getWallet",
    value: function getWallet(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var result;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetWallet, request.toArray());

              case 2:
                result = _context13.sent;
                return _context13.abrupt("return", result);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "getSpendableOutpoints",
    value: function getSpendableOutpoints(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var result;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetSpendableOutpoints, request.toArray());

              case 2:
                result = _context14.sent;
                return _context14.abrupt("return", result);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "getSpendableCollateral",
    value: function getSpendableCollateral(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var result;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetSpendableCollateral, request.toArray());

              case 2:
                result = _context15.sent;
                return _context15.abrupt("return", result);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "getUnlockTakerTxParams",
    value: function getUnlockTakerTxParams(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        var result;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetUnlockTakerTxParams, request.toArray());

              case 2:
                result = _context16.sent;
                return _context16.abrupt("return", result);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "getOpenOrders",
    value: function getOpenOrders(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        var result;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetOpenOrders, request.toArray());

              case 2:
                result = _context17.sent;
                return _context17.abrupt("return", result);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "sendTx",
    value: function sendTx(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18() {
        var result;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.SendTx, Buffer.from(request.serializeBinary()));

              case 2:
                result = _context18.sent;
                return _context18.abrupt("return", result);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "getMatchedOrders",
    value: function getMatchedOrders(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var result;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetMatchedOrders, Buffer.from(request.serializeBinary()));

              case 2:
                result = _context19.sent;
                return _context19.abrupt("return", result);

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "getBlake2Bl",
    value: function getBlake2Bl(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        var result;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetBlake2bl, request.toArray());

              case 2:
                result = _context20.sent;
                return _context20.abrupt("return", result);

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "getTxClaimedBy",
    value: function getTxClaimedBy(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        var result;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetTxClaimedBy, request.toArray());

              case 2:
                result = _context21.sent;
                return _context21.abrupt("return", result);

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "getTradeStatus",
    value: function getTradeStatus(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22() {
        var result;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetTradeStatus, request.toArray());

              case 2:
                result = _context22.sent;
                return _context22.abrupt("return", result);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
  }, {
    key: "getOutpointStatus",
    value: function getOutpointStatus(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        var result;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetOutpointStatus, request.toArray());

              case 2:
                result = _context23.sent;
                return _context23.abrupt("return", result);

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "getBcAddressViaVanity",
    value: function getBcAddressViaVanity(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        var result;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.makeJsonRpcRequest(BcRpcMethod.GetBcAddressViaVanity, request.toArray());

              case 2:
                result = _context24.sent;
                return _context24.abrupt("return", result);

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "makeJsonRpcRequest",
    value: function makeJsonRpcRequest(method, rpcParams) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        var id, rpcBody, res, jsonResult;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                id = Math.abs(Math.random() * 1e6 | 0);
                /* tslint:disable-line */
                // this bitwise operation is intentional

                rpcBody = {
                  id: id,
                  jsonrpc: '2.0',
                  method: method,
                  params: rpcParams
                };
                _context25.prev = 2;
                _context25.next = 5;
                return fetch("".concat(this.rpcUrl.origin, "/rpc"), {
                  body: JSON.stringify(rpcBody),
                  headers: this.defaultHeaders,
                  method: 'post'
                });

              case 5:
                res = _context25.sent;
                _context25.next = 11;
                break;

              case 8:
                _context25.prev = 8;
                _context25.t0 = _context25["catch"](2);
                return _context25.abrupt("return", {
                  code: -1,
                  message: _context25.t0.toString()
                });

              case 11:
                if (!(res.status !== 200)) {
                  _context25.next = 13;
                  break;
                }

                return _context25.abrupt("return", {
                  code: res.status,
                  message: res.statusText
                });

              case 13:
                _context25.next = 15;
                return res.json();

              case 15:
                jsonResult = _context25.sent;

                if (!('code' in jsonResult)) {
                  _context25.next = 18;
                  break;
                }

                return _context25.abrupt("return", jsonResult);

              case 18:
                if (!(jsonResult.id !== id)) {
                  _context25.next = 20;
                  break;
                }

                return _context25.abrupt("return", {
                  code: -32603,
                  message: "Ids didn't match - sent ".concat(id, ", got ").concat(jsonResult.id)
                });

              case 20:
                return _context25.abrupt("return", jsonResult.result);

              case 21:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[2, 8]]);
      }));
    }
  }]);

  return RpcClient;
}();

exports.default = RpcClient;